import { Controller } from "react-hook-form";
import "./element.scss";
import DateTimePicker from "../../../date-time-picker/date-time-picker";
import dayjs from "dayjs";


interface DynamicDateTimeProps {
  formControl: any;
  fieldArrayName: string;
  name: string;
  label?: string;
  placeholder?: string;
  defaultValue?: any;
  required?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  formType?: string;
}

const DynamicDateTime = (props: DynamicDateTimeProps) => {
  const {readOnly=false} = props
  return (
    <Controller
      control={props.formControl}
      name={`${props.fieldArrayName}.${props.name}`}
      render={({ field, fieldState }) => (
        <DateTimePicker
          {...field}
          dataPosition={props.position}
          dataName={`${props.fieldArrayName}.${props.name}`}
          label={props.label}
          placeholder={props.placeholder}
          required={props.formType === "builder" ? false : props.required}
          defaultValue={props.defaultValue}
          disableFutureDates={props.is_future_dates_allowed}
          disablePastDates={props.is_past_dates_allowed}
          helperText={fieldState.error?.message}
          error={Boolean(fieldState.error)}
          disabled={props.disabled}
          minDate={props.min_date}
          maxDate={props.max_date}
          minDateTime={props.min_date_time}
          maxDateTime={props.max_date_time}
          textFieldProps={readOnly? {readOnly: true} : {readOnly: false}}
          onChange={(newValue) => {
            if (props.min_date_time && newValue && dayjs(newValue).isSame(props.min_date_time, 'day')) {
              const selected = dayjs(newValue);
              // if time is earlier than min allowed time on same day, adjust it
              if (selected.isBefore(props.min_date_time)) {
                const adjusted = selected.hour(props.min_date_time.hour()).minute(props.min_date_time.minute());
                field.onChange(adjusted);
                return;
              }
            }
        
            field.onChange(newValue);
          }}
        />
      )}
    />
  );
};
export { DynamicDateTime };
export default DynamicDateTime;
